import { FormProvider, useForm } from "react-hook-form";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { PartnersAutocomplete } from "@shared/components/AutocompleteFields";
import { useGenerateMonthlyMutation } from "@modules/partners/services/mutations";

interface GenerateMonthlyDialogProps {
  open: boolean;
  onClose: () => void;
}

interface GenerateFormValues {
  partner_id?: number | null;
  year?: string;
  month?: string;
}

export function GenerateMonthlyDialog({ open, onClose }: GenerateMonthlyDialogProps) {
  const translate = useTranslate();
  const generateMutation = useGenerateMonthlyMutation();
  const methods = useForm<GenerateFormValues>({ defaultValues: {} });

  const onSubmit = methods.handleSubmit(async (values) => {
    await generateMutation.mutateAsync({
      partner_id: values.partner_id ?? undefined,
      year: values.year ? Number(values.year) : undefined,
      month: values.month ? Number(values.month) : undefined,
    });
    onClose();
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{translate("v1/partner_monthly_admin.generate.title")}</DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <Grid container spacing={2} sx={{ mt: 0 }}>
            <Grid size={{ xs: 12 }}>
              <PartnersAutocomplete
                name="partner_id"
                label={translate("v1/partner_monthly_admin.generate.partner")}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <Form.Input
                name="year"
                label={translate("v1/partner_monthly_admin.generate.year")}
              />
            </Grid>
            <Grid size={{ xs: 6 }}>
              <Form.Input
                name="month"
                label={translate("v1/partner_monthly_admin.generate.month")}
              />
            </Grid>
          </Grid>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{translate("buttons.cancel")}</Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={generateMutation.isPending}
        >
          {translate("partners.actions.generate")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
